var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewTab(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.09945 0.568102C9.35354 0.0970909 13.6466 0.0970909 17.9007 0.568102C20.2561 0.832102 22.1563 2.68698 22.4327 5.0506C22.9368 9.36534 22.9368 13.7241 22.4327 18.0389C22.1563 20.4025 20.2561 22.2574 17.9007 22.5214C13.6466 22.9924 9.35354 22.9924 5.09945 22.5214C2.74408 22.2574 0.843828 20.4025 0.567453 18.0389C0.0634532 13.7246 0.0634532 9.36627 0.567453 5.05198C0.707246 3.90367 1.23072 2.83623 2.05305 2.02264C2.87537 1.20905 3.94835 0.697 5.09808 0.569477M11.5001 4.67935C11.7736 4.67935 12.0359 4.788 12.2293 4.9814C12.4227 5.17479 12.5313 5.4371 12.5313 5.7106V10.5135H17.3342C17.6077 10.5135 17.87 10.6221 18.0634 10.8155C18.2568 11.0089 18.3655 11.2712 18.3655 11.5447C18.3655 11.8182 18.2568 12.0805 18.0634 12.2739C17.87 12.4673 17.6077 12.576 17.3342 12.576H12.5313V17.3789C12.5313 17.6524 12.4227 17.9147 12.2293 18.1081C12.0359 18.3015 11.7736 18.4101 11.5001 18.4101C11.2266 18.4101 10.9643 18.3015 10.7709 18.1081C10.5775 17.9147 10.4688 17.6524 10.4688 17.3789V12.576H5.66595C5.39245 12.576 5.13015 12.4673 4.93675 12.2739C4.74335 12.0805 4.6347 11.8182 4.6347 11.5447C4.6347 11.2712 4.74335 11.0089 4.93675 10.8155C5.13015 10.6221 5.39245 10.5135 5.66595 10.5135H10.4688V5.7106C10.4688 5.4371 10.5775 5.17479 10.7709 4.9814C10.9643 4.788 11.2266 4.67935 11.5001 4.67935Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewTab);
export default __webpack_public_path__ + "static/media/new-tab.dfe074645b85066dc342de736aee4d26.svg";
export { ForwardRef as ReactComponent };